module.exports = __webpack_public_path__ + "static/media/add.31be9b85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/add.svg
// module id = 5
// module chunks = 1